export const GET_EAADHAAR_LOADING = "GET_EAADHAAR_LOADING";
export const GET_EAADHAAR_SUCCESS = "GET_EAADHAAR_SUCCESS";
export const GET_EAADHAAR_FAILED = "GET_EAADHAAR_FAILED";

export const GET_EAADHAAR_CAPTCHA_LOADING = "GET_EAADHAAR_CAPTCHA_LOADING";
export const GET_EAADHAAR_CAPTCHA_SUCCESS = "GET_EAADHAAR_CAPTCHA_SUCCESS";
export const GET_EAADHAAR_CAPTCHA_FAILED = "GET_EAADHAAR_CAPTCHA_FAILED";

export const GET_AADHAAR_LINKED_OTP_LOADING = "GET_AADHAAR_LINKED_OTP_LOADING";
export const GET_AADHAAR_LINKED_OTP_SUCCESS = "GET_AADHAAR_LINKED_OTP_SUCCESS";
export const GET_AADHAAR_LINKED_OTP_FAILED = "GET_AADHAAR_LINKED_OTP_FAILED";

export const VERIFY_AADHAAR_LINKED_OTP_LOADING =
  "VERIFY_AADHAAR_LINKED_OTP_LOADING";
export const VERIFY_AADHAAR_LINKED_OTP_SUCCESS =
  "VERIFY_AADHAAR_LINKED_OTP_SUCCESS";
export const VERIFY_AADHAAR_LINKED_OTP_FAILED =
  "VERIFY_AADHAAR_LINKED_OTP_FAILED";

export const SAVE_EAADHAAR_LOADING = "SAVE_EAADHAAR_LOADING";
export const SAVE_EAADHAAR_SUCCESS = "SAVE_EAADHAAR_SUCCESS";
export const SAVE_EAADHAAR_FAILED = "SAVE_EAADHAAR_FAILED";
